type GtagCommand = (command: "event", eventName: string, params?: Record<string, unknown>) => void;

/**
 * Sends an event to Google Analytics (gtag.js). No-op during SSR and when GA is
 * not loaded (e.g. environments without a measurement ID), so callers don't need
 * to guard for it.
 */
export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
	if (typeof window === "undefined") {
		return;
	}

	const { gtag } = window as unknown as { gtag?: GtagCommand };
	if (typeof gtag !== "function") {
		return;
	}

	gtag("event", eventName, params);
}
